<template lang="pug">
  div(:style="'min-height:'+h")
    div.px-0.white.detail-head.head-border
      el-row.pl-5
        el-col(:span="8")
          Breadcrumb
        el-col.pt-5.text-right(:span="15")
          el-button(v-if="true" type="primary" size="mini" @click="handleAdd") 新增菜单
    div(style="height:70px")
    el-main.white.pa-3.ma-4
      el-table(:data="data" v-loading="loading" row-key="id" size="mini" :tree-props="{children: 'children'}")
        el-table-column(prop="title" label="名称" width="200")
        el-table-column(prop="name" label="路由名称" width="200")
        el-table-column(prop="icon" label="图标" width="80")
          template(slot-scope="scope")
            i.iconfont(v-html="scope.row.icon")
        el-table-column(prop="op" label="页面按钮")
        el-table-column(prop="sort" label="排序")
        el-table-column(label="操作" width="120")
          template(slot-scope="scope")
            el-button(size="mini" type="text" @click="handleEdit(scope.$index, scope.row)") 编辑
            el-button(size="mini" type="text" @click="handleDelete(scope.$index, scope.row)") 删除
    el-dialog.dialog(title="新增菜单" :visible.sync="dialogFormVisible" width="380px" :show-close="false" :destroy-on-close="true" :append-to-body="true" :close-on-press-escape="false" :close-on-click-modal="true")
      el-form(:model="form" ref="form" size="mini" label-width="90px" :rules="rules")
        el-form-item(label="菜单名称" prop="title")
          el-input(v-model="form.title" placeholder="左侧显示")
        el-form-item(label="父节点" prop="pid")
          el-select(v-model="form.pid" filterable placeholder="请选择")
            el-option(v-for="item in options" :key="item.id" :label="item.title" :value="item.id")
        el-form-item(label="路由名称" prop="name")
          el-input(v-model="form.name" placeholder="请确保值唯一")
        el-form-item(label="图标")
          el-input(v-model="form.icon")
        el-form-item(label="按钮")
          el-select(v-model="form.op" multiple filterable placeholder="请选择")
            el-option(v-for="item in btns" :key="item.code" :label="item.name" :value="item.code")
        el-form-item(label="排序")
          el-input-number(v-model="form.sort" :min="0")
      div(slot="footer" class="dialog-footer")
        el-button(size="mini" @click="dialogFormVisible = false") 取 消
        el-button(size="mini" type="primary" @click="submitForm") 确 定
</template>
<script>
export default {
  data() {
    return {
      h: 0,
      loading: false,
      data: [],
      dialogFormVisible: false,
      options: [
        {
          id: 0,
          title: "根节点",
        },
      ],
      form: {
        title: "",
        pid: null,
        name: "",
        icon: "",
        sort: 0,
        op: [],
      },
      rules: {
        title: [{ required: true, message: "请输菜单名称", trigger: "blur" }],
        pid: [{ required: true, message: "请选择父节点", trigger: "change" }],
        name: [{ required: true, message: "请填写路由名称", trigger: "blur" }],
      },
      btns: [],
      list: {
        page_num: 1,
        page_size: 100,
      },
    };
  },
  methods: {
    async getMenu() {
      this.loading = true;
      let res = await this.$api.menu.getMenu();
      this.loading = false;
      if (res) {
        this.data = res.data;
        this.options = this.$utils.cloneDeep(this.data);
        this.options.unshift({ id: 0, title: "根节点" });
      }
    },
    async getBtn() {
      let res = await this.$api.btn.getList(this.list);
      if (res) {
        this.btns = res.data;
      }
    },
    handleAdd() {
      this.dialogFormVisible = true;
      this.title = "新增";
      this.form = {
        title: "",
        pid: null,
        name: "",
        icon: "",
        sort: 0,
        op: [],
      };
    },
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.title = "编辑";
      this.form = this.$utils.cloneDeep(row);
      this.form.op = this.form.op ? this.form.op.split(",") : [];
    },
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.loading = true;
          let res = await this.$api.menu.del(row.id);
          this.loading = false;
          if (res) {
            this.getMenu();
            this.$notify({
              message: "操作成功",
              type: "success",
            });
          }
        })
        .catch(() => {});
    },
    submitForm() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          let res = null;
          let data = this.$utils.cloneDeep(this.form);
          data.op = this.form.op.toString();
          if (this.title == "新增") {
            res = await this.$api.menu.add(data);
          } else {
            res = await this.$api.menu.edit(data);
          }
          if (res) {
            this.dialogFormVisible = false;
            this.getMenu();
            this.$notify({
              message: "操作成功",
              type: "success",
            });
          }
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
    this.h = document.body.clientHeight - 61 + "px";
  },
  created() {
    this.getMenu();
    this.getBtn();
  },
};
</script>